var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"mt-2 mt-lg-0",attrs:{"src":_vm.src,"alt":"Logo","height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }